// extracted by mini-css-extract-plugin
export var dropdownButton = "_25-0";
export var fullWidthDropdownButton = "_25-1";
export var icon = "_25-3";
export var iconPlaceholder = "_25-2";
export var menuItemRow = "_25-9";
export var separator = "_25-e";
export var shortcutContainer = "_25-7";
export var shortcutContainerFilled = "_25-8";
export var shortcutIconLg = "_25-6";
export var shortcutIconMd = "_25-5";
export var shortcutIconSm = "_25-4";
export var submenuChevron = "_25-d";
export var submenuDropdown = "_25-a";
export var submenuTriggerRow = "_25-b";
export var submenuTriggerRowOpen = "_25-c";